let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("5V2x3")).then(() => parcelRequire('60bto'));